import styled from 'styled-components';
import { colors } from '@dexma/ui-components';

export const StyledDataForm = styled.form`
    .widget-type-block span {
        font-weight: 700;
        color: ${colors.gray700};
    }

    .feature-preset-label-block {
        padding: 20px 30px 0px 30px;
    }

    .feature-preset-block {
        padding: 10px 30px 0px 30px;
    }

    .feature-preset {
        font-size: 1rem;
        color: ${colors.gray900};
    }
`;
